const SESSION_HEADER = 'X-Requirement-Edit-Session';

let boundProjectId: number | null = null;
let boundSessionId: string | null = null;

export function bindRequirementEditSession(projectId: number, sessionId: string) {
  boundProjectId = Number.isFinite(projectId) && projectId > 0 ? projectId : null;
  boundSessionId = sessionId?.trim() || null;
}

export function unbindRequirementEditSession(projectId?: number, sessionId?: string) {
  // KeepAlive may destroy an older cached project after another project is active.
  // An old instance must not clear the newer instance's global binding.
  if (projectId != null && sessionId != null) {
    if (boundProjectId !== Number(projectId) || boundSessionId !== sessionId.trim()) return;
  }
  boundProjectId = null;
  boundSessionId = null;
}

export function attachRequirementEditSessionHeader(
  url: string,
  headers: Record<string, string>,
): Record<string, string> {
  if (!boundProjectId || !boundSessionId) return headers;
  const path = String(url || '');
  if (!path.includes(`/projects/${boundProjectId}`)) return headers;
  headers[SESSION_HEADER] = boundSessionId;
  return headers;
}
